import { toast } from 'react-toastify';

const showValidateErrors = (errors) => {
  if (!Array.isArray(errors)) return;
  errors.forEach((err) =>
    err.message.forEach((msg) =>
      toast.error(msg, { position: 'top-right', autoClose: 3000 })
    )
  );
};

export default showValidateErrors;
